module.exports = __webpack_public_path__ + "media/images/admin/icons/help-circle-b9cadc2460c71b7b4b69e1009a570d1d.svg";